import React from 'react'
import { TrendingDown, TrendingUp } from 'react-feather';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import colors from 'theme/colors';

export default function FinancialStatusIcon({ status }) {
    return (
        <TransactionIconCircle status={status}>
            {status === 'withdraw' && <TrendingDown size={18}  />}
            {status === 'refund' && <TrendingDown size={18}  />}
            {status === 'sell' && <TrendingUp size={18}  />}
        </TransactionIconCircle>

    )
}

const TransactionIconCircle = styled(FullyCentered)`
    border-radius: 50%;
    width: 38px;
    height: 38px;
    padding: 5px;
    margin-right: 10px;
    
    ${({ status }) => status === 'sell' && `
        background-color: #DCFCE7;
        & > svg { 
            fill: ${colors.success};
            stroke: ${colors.success};
        }
        `}
    
    ${({ status }) => status === 'pending' && `
        background-color: ${colors.occasionalOrange};
        color: ${colors.success};
    `}
   
   ${({ status }) => status === 'refund' && `
        background-color: #f2c4c4;
        color: ${colors.success};
        & > svg { 
            fill: ${colors.dangerDark};
            stroke: ${colors.dangerDark};
        }
    `}
  
  ${({ status }) => status === 'withdraw' && `
        background-color: #E6F1FE;
        color: ${colors.success};
        & > svg { 
            fill: ${colors.primary};
            stroke: ${colors.primary};
        }
    `}
`;